/**
 * Beacon de navegación → internal.pageView (AccessLogsTable, evento 'page').
 * Registra "quién entró a dónde" incluso en páginas que no llaman a la API.
 * Solo autenticados; deduplica el mismo pathname consecutivo. Fire-and-forget
 * en el cliente: si falla, no molesta a nadie.
 */
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trpc } from '@/lib/trpc';
import { useAuth } from '@/contexts/SharedAuthContext';

export function PageViewBeacon() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const pageView = trpc.internal.pageView.useMutation();
  const last = useRef('');
  const mutateRef = useRef(pageView.mutate);
  mutateRef.current = pageView.mutate;

  useEffect(() => {
    if (!user) return;
    if (pathname === last.current) return;
    if (pathname === '/login' || pathname === '/unauthorized') return;
    last.current = pathname;
    try {
      mutateRef.current({ path: pathname });
    } catch {
      /* nunca romper la navegación por telemetría */
    }
  }, [pathname, user]);

  return null;
}
